import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ReactTable from "react-table";
import moment from "moment";
import Spinner from "../../../common/Spinner";
import {
    createClientCharges,
    fetchMissingClientCharges
} from "../../../../api/menu/invoicing/actions";
import CustomCheckbox from "../../../custom/forms/custom-checkbox";
import filterCaseInsensitive from "../../../custom/forms/react-table-case-insensitive";
import MissingChargesHeader from "./missingChargesHeader";

class MissingClientChargesList extends React.Component {
    dateFormat = "YYYY-MM-DD";

    constructor(props) {
        super(props);

        this.state = {
            fromDate: moment(moment().startOf("month").format(this.dateFormat)),
            selectedMissingClientCharges: []
        };

        this.handleLoadData = this.handleLoadData.bind(this);
        this.setFromDate = this.setFromDate.bind(this);
        this.handleCreateCharge = this.handleCreateCharge.bind(this);
        this.setSelectedMissingClientCharges =
            this.setSelectedMissingClientCharges.bind(this);
    }

    handleCreateCharge() {
        const { selectedMissingClientCharges } = this.state;

        this.props.createClientCharges(
            selectedMissingClientCharges,
            this.handleLoadData
        );
    }

    handleLoadData() {
        const date = this.state.fromDate && moment(this.state.fromDate).format(this.dateFormat);
        this.props.getMissingClientCharges(date);
    }

    setFromDate(date) {
        this.setState({
            fromDate: date
        });
    }

    setSelectedMissingClientCharges(id) {
        const selectedCharges = Object.assign([], this.state.selectedMissingClientCharges);

        const index = selectedCharges.indexOf(id);

        if (index >= 0) {
            selectedCharges.splice(index, 1);
        } else {
            selectedCharges.push(id);
        }

        this.setState({
            selectedMissingClientCharges: selectedCharges
        });
    }

    onToggle = () => {
        const { selectedMissingClientCharges } = this.state;
        const { missingClientCharges } = this.props;

        const selectedCharges =
            selectedMissingClientCharges.length === missingClientCharges.length ?
                [] : missingClientCharges.map(i => i.serviceId);

        this.setState({
            selectedMissingClientCharges: selectedCharges
        });
    };

    getColumns = () => {
        const { selectedMissingClientCharges } = this.state;
        const { missingClientCharges } = this.props;

        const columns = [];

        columns.push({
            Cell: ({ original }) => (
                <CustomCheckbox
                    key={original.chargeId}
                    className="checkbox"
                    checked={selectedMissingClientCharges.includes(original.chargeId)}
                    onChange={() => this.setSelectedMissingClientCharges(original.chargeId)}
                />
            ),
            headerClassName: "text-left",
            Header: () => (
                <input
                    type="checkbox"
                    className="checkbox"
                    checked={selectedMissingClientCharges.length ?
                        selectedMissingClientCharges.length ===
                        missingClientCharges.length : false}
                    onChange={() => this.onToggle()}
                />
            ),
            sortable: false,
            filterable: false,
            resizable: false,
            minResizeWidth: 40,
            width: 40,
            className: "d-flex"
        });
        columns.push({
            Header: "Merchandiser",
            headerClassName: "text-left",
            accessor: "merchandiser"
        });
        // columns.push({
        //     Header: "Job",
        //     headerClassName: "text-left",
        //     accessor: original => moment(original.dateIssued).format(this.dateFormat)
        // });
        columns.push({
            Header: "Job",
            headerClassName: "text-left",
            accessor: "jobNumber"
        });
        columns.push({
            Header: "Store",
            headerClassName: "text-left",
            accessor: "storeNumber"
        });
        columns.push({
            id: "completed",
            Header: "Completed",
            headerClassName: "text-left",
            accessor: original => (original.completedDate ?
                moment(original.completedDate).format("DD/MM/YYYY") : "")
        });
        columns.push({
            id: "submitted",
            Header: "Submitted",
            headerClassName: "text-left",
            accessor: original => moment(original.dateReportSubmitted).format("DD/MM/YYYY hh:mm A")
        });
        columns.push({
            Header: "Status",
            headerClassName: "text-left",
            accessor: "approvalStatus"
        });
        columns.push({
            Header: "Hours",
            headerClassName: "text-left",
            accessor: "billableHours"
        });
        columns.push({
            Header: "Hourly Rate",
            headerClassName: "text-left",
            accessor: "payratePerHour"
        });
        columns.push({
            Header: "Flat Rate",
            headerClassName: "text-left",
            accessor: "payrateFlat"
        });
        columns.push({
            id: "invoiced",
            Header: "Invoiced?",
            headerClassName: "text-left",
            accessor: original => (original.isInvoiced ? "Yes" : "No"),
            Cell: ({ original }) => (original.isInvoiced ? "Yes" : "No"),
        });
        columns.push({
            id: "isDeleted",
            Header: "Deleted?",
            headerClassName: "text-left",
            accessor: original => (original.isDeleted ? "Yes" : "No"),
            Cell: ({ original }) => (original.isDeleted ? "Yes" : "No"),
        });
        columns.push({
            Header: "ChargeId",
            headerClassName: "text-left",
            accessor: "chargeId"
        });

        return columns;
    };

    render() {
        const { selectedMissingClientCharges } = this.state;
        const { missingClientCharges } = this.props;

        const enableCreate = Array.isArray(selectedMissingClientCharges) &&
            selectedMissingClientCharges.length > 0;

        const selectedText = selectedMissingClientCharges.length ?
            `Selected ${selectedMissingClientCharges.length} out of ${missingClientCharges.length}` : "";

        return (
            <div className="dashboard">
                <div className="position-relative">
                    {!this.props.missingClientChargesLoading || <Spinner/>}
                    <MissingChargesHeader
                        fromDate={this.state.fromDate}
                        selectedText={selectedText}
                        handleLoad={this.handleLoadData}
                        handleCreate={this.handleCreateCharge}
                        setFromDate={this.setFromDate}
                        enableCreate={enableCreate}
                    />
                    <ReactTable
                        data={missingClientCharges}
                        columns={this.getColumns()}
                        headerClassName="table-header"
                        showPagination={false}
                        pageSize={Math.max(missingClientCharges.length, 20)}
                        resizable
                        className="-striped -highlight"
                        filterable={false}
                        defaultFilterMethod={filterCaseInsensitive}
                        getNoDataProps={() => ({
                            style: {
                                zIndex: 0
                            }
                        })}
                        style={{
                            height: "calc(100vh - 180px)",
                        }}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    missingClientChargesLoading: state.invoicing.missingClientChargesLoading,

    missingClientCharges: state.invoicing.missingClientCharges
});

const mapStateToDispatch = dispatch => ({
    getMissingClientCharges: bindActionCreators(fetchMissingClientCharges, dispatch),
    createClientCharges: bindActionCreators(createClientCharges, dispatch)
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(MissingClientChargesList);
